<template>
    <div id="residence-agreement-form">
        <v-card>
            <v-card elevation="0">
                <v-card-title>
                    King’s University College - Rules of Residence
                </v-card-title>
                <VersionMay2025 />
                <v-form ref="rulesOfResidenceForm" v-model="agreed">
                    <v-card-text class="pt-0 pb-0">
                        <v-container fluid>
                            <v-row>
                                <v-col cols="12" md="12">
                                    <v-checkbox
                                        v-model="applicant.rulesOfResidence.signed"
                                        label="By accepting my residence offer and paying the required deposit, I acknowledge that I have read, understood, and agree to abide by the Rules of Residence. I understand that these rules are subject to change."
                                        true-value="yes"
                                        false-value="no"
                                        required
                                        :rules="applicantRulesOfResidenceRules"
                                    ></v-checkbox>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                </v-form>
            </v-card>
            <!-- <v-card elevation="0" v-if="!showAgreement">
                <v-card-text>
                    <v-row>
                        <v-col cols="12"> </v-col>
                        <v-col cols="12">
                            Upon review and approval of the application, and receipt of the required deposit, students will be issued a lease for signature.
                        </v-col>
                        <v-col cols="12"> </v-col>
                    </v-row>
                </v-card-text>
            </v-card> -->
            <v-card-actions>
                <v-spacer>
                </v-spacer>
                <v-btn class="white--text" :color="successColor" :disabled="!agreed" @click="nextStep(7)">
                    Next
                </v-btn>
                <v-btn class="white--text" :color="kingsGrey" @click="prevStep(5)">
                    Previous
                </v-btn>
            </v-card-actions>
        </v-card>
    </div>
</template>
<script>
import VersionMay2025 from "../RulesOfResidence/May2025.vue"
export default {
    name: 'rules-of-residence-form',
    components: {
        VersionMay2025
    },
    props: {
        applicant: {
            required: true
        },
    },
    data() {
        return {
            agreed: false,
            version: '1',
            applicantRulesOfResidenceRules: [
                v => v == 'yes' || 'You must read and agree to the Rules of Residence',
            ],
        }
    },
    methods: {
        nextStep(val) {
            if (this.$refs.rulesOfResidenceForm.validate()) {
                this.$emit('setStep', val);
                this.$nextTick(() => {
                    this.$emit('scrollToTop');
                })
            }
        },
        prevStep(step) {
            this.$emit('setStep', step);
            this.$nextTick(() => {
                this.$emit('scrollToTop');
            })
        },
    },
    computed: {
        infoColor() {
            return '#5578eb';
        },
        kingsGrey() {
            return '#6d6e71';
        },
        successColor() {
            return '#1bc5bd';
        },
        warningColor() {
            return '#ffb822'
        },
        showAgreement(){
            let buildingOption1 = false
            let buildingOption2 = false
            let upperyears = ["2", "3", "4"]
            let isUpperYear = false

            buildingOption1 = this.applicant.buildingOption01 != "" && (/Epworth Place/i.test(this.applicant.buildingOption01) || /King's Commons/i.test(this.applicant.buildingOption01)) ? true : false
            buildingOption2 = this.applicant.buildingOption02 != "" && (/Epworth Place/i.test(this.applicant.buildingOption02) || /King's Commons/i.test(this.applicant.buildingOption02)) ? true : false
            isUpperYear = this.applicant.yearOfStudy != "" && upperyears.includes(this.applicant.yearOfStudy)

            if (buildingOption1 && buildingOption2 && isUpperYear){
                return false
            }

            return true
        }
    }
}
</script>

<style scoped>
.applicant__commonname {
    font-size: 20px;
    font-weight: bold;
    text-decoration: underline;
}
</style>